// src/scene/OfficeRoom.tsx
/**
 * Low Poly Office Room
 * Auto-generated by: https://github.com/pmndrs/gltfjsx
 */

import { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { Group, Mesh } from 'three'

interface OfficeRoomProps {
  position?: [number, number, number]
  rotation?: [number, number, number]
  scale?: number | [number, number, number]
}

export function OfficeRoom({
  position = [0, 0, 0],
  rotation = [0, 0, 0],
  scale = 1
}: OfficeRoomProps) {
  const groupRef = useRef<Group>(null)
  const { nodes, materials } = useGLTF('/LP_Officeroom2.glb') as any as { nodes: Record<string, Mesh>; materials: Record<string, any> }

  return (
    <group
      ref={groupRef}
      position={position}
      rotation={rotation}
      scale={scale}
      dispose={null}
    >
      <group rotation={[Math.PI / 2, 0, 0]} scale={0.01}>
        {/* ---- Structural / large meshes: keep castShadow ---- */}
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Office2_base.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Office2_carpet.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Office2_chair.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Office2_little_table.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Office2_monitor1.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Office2_shelves.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Office2_sofa.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Office2_stand.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Office2_table.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Office2_Vinyl_players.geometry}
          material={materials['LP_Rooms.001']}
        />

        {/* ---- Floor surfaces: receiveShadow only ---- */}
        <mesh
          receiveShadow
          geometry={nodes.Office2_parquet1.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          receiveShadow
          geometry={nodes.Office2_parquet2.geometry}
          material={materials['LP_Rooms.001']}
        />

        {/* ---- Small decorative objects: no castShadow ---- */}
        <mesh
          geometry={nodes.Office2_Books1.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_Books10.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_Books11.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_Books12.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_Books13.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_Books14.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_Books15.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_Books16.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_Books2.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_Books3.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_Books4.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_Books5.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_Books6.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_Books7.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_Books8.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_Books9.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_box_1.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_box_2.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_box_3.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_box_4.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_box_5.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_box_6.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_box_7.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_clock_1.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_decoration1.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_decoration2.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_Flower.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_Keyboard.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_magazines1.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_magazines2.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_magazines3.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_magazines4.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_magazines5.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_Mouse.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_Pens.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_Photoframe1.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_Photoframe_2.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_Photoframe_3.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_Photoframe_4.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_picture.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_Room_Paper.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_vial_1.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_vial_2.geometry}
          material={materials['LP_Rooms.001']}
        />
        <mesh
          geometry={nodes.Office2_Vinyls.geometry}
          material={materials['LP_Rooms.001']}
        />
      </group>
    </group>
  )
}

// Preload the model
useGLTF.preload('/LP_Officeroom2.glb')

export default OfficeRoom
